import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
// React Icons
import { FiSettings } from "react-icons/fi";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { PiUsersThreeThin } from "react-icons/pi";
import { TbReportMoney } from "react-icons/tb";
import { GiExpense } from "react-icons/gi";
import { LiaUsersCogSolid } from "react-icons/lia";
import "../../index.css";
// Custom hooks
import { useTenant } from "../../hooks";

const MenuSide = ({ openMenu, setOpenMenu }) => {
  const [t] = useTranslation("global");
  const { tenantUsername } = useTenant();
  const location = useLocation();
  const isActiveincome = location.pathname.includes("income");
  const isActiveexpenses = location.pathname.includes("expenses");
  const isActivevendors = location.pathname.includes("vendors");
  const isActivecustomers = location.pathname.includes("customers");
  const isActivereports = location.pathname.includes("reports");
  const isActivesettings = location.pathname.includes("settings");
  const isActiveseuser = location.pathname.includes("user");
  return (
    <div
      // onMouseOver={()=>setOpenMenu(true)}
      className={`  z-10   flex items-center   transition-all duration-500  ease-out  h-screen       primary-bg-color   justify-center   ${
        openMenu
          ? "fixed  w-10 flex md:w-40 md:relative "
          : "fixed w-0 hidden md:flex md:w-[52px]   "
      }`}
    >
      <ul className=" cursor-default  flex w-full flex-col gap-5 items-center  text-white  text-xs  ">
        <li
          data-title={t("menu.Dashboard")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}`}
            className={`flex items-center gap-2 `}
            end
          >
            <img
              className="w-6 z-50"
              src="/assets/icons/dashboard-svgrepo-com 1.png"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
        {/* <li className={`w-full menu-border-color border-b pb-2 hover:text-yellow-400 ${ openMenu || 'justify-center' } `}>
                        <NavLink to={`/${tenantUsername}/memberships/add`} className={`flex items-center gap-2 `} end >
                            <MdOutlineAddBox size={25} title="أضف عضوية جديدة" />
                            { openMenu && <span className='whitespace-nowrap hidden md:flex'>أضف عضوية جديدة</span>}
                        </NavLink>
                    </li> */}

        <li
          data-title={t("menu.Saleries")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/incomes`}
            className={`flex items-center gap-2 ${
              isActiveincome ? "active" : ""
            }`}
            end
          >
            <img
              className="w-6 z-50"
              src="/assets/icons/money-recive-svgrepo-com 1.png"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
        <li
          data-title={t("menu.Expenses")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/expenses`}
            className={`flex items-center gap-2 ${
              isActiveexpenses ? "active" : ""
            }`}
            end
          >
            <img
              className="w-6 z-50"
              src="/assets/icons/money-recive-svgrepo-com 2.png"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
        <li
          data-title={t("menu.Customers")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/customers`}
            className={`flex items-center gap-2 ${isActivecustomers ? "active" : ""}`}
            end
          >
            <PiUsersThreeThin size={26} className="z-50" />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
        <li
          data-title={t("vendors.title")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/vendors`}
            className={`flex items-center gap-2 ${isActivevendors ? "active" : ""}`}
            end
          >
            <LiaUsersCogSolid size={26} className="z-50" />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>

        {/* 
                    <li className={`w-full menu-border-color  border-b pb-2 hover:text-yellow-400 ${ openMenu || 'justify-center' } `}>
                        <NavLink to={`/${tenantUsername}/memberships-subscriptions`} className={`flex items-center gap-2 `} end >
                            <RiQuoteText size={25} title=' اشتراكات الاعضاء '  />
                            { openMenu && <span className='whitespace-nowrap hidden md:flex'>اشتراكات الاعضاء </span>}
                        </NavLink>
                    </li>
                    <li className={`w-full menu-border-color  border-b pb-2 hover:text-yellow-400 ${ openMenu || 'justify-center' } `}>
                        <NavLink to={`/${tenantUsername}/invoices`} className={`flex items-center gap-2 `} end >
                            <FaFileInvoice size={25} title='الفواتير'  />
                            { openMenu && <span className='whitespace-nowrap hidden md:flex'> الفواتير </span>}
                        </NavLink>
                    </li>
                    <li className={`w-full menu-border-color  border-b pb-2 hover:text-yellow-400 ${ openMenu || 'justify-center' } `}>
                        <NavLink to={`/${tenantUsername}/transactions`} className={`flex items-center gap-2 `} end >
                            <LiaFileInvoiceDollarSolid size={25} title='سندات الدفع'  />
                            { openMenu && <span className='whitespace-nowrap hidden md:flex'> سندات الدفع </span>}
                        </NavLink>
                    </li> */}

        {/* <li 
                        className={` w-full gap-2 flex items-center  border-indigo-100/50  border-b pb-1 hover:text-indigo-600 ${ openMenu || 'justify-center' } `}>
                        <CiDiscount1 size={20} title={t('menu.Promotions')}/>
                        { openMenu && <span className='whitespace-nowrap hidden md:flex'>{t('menu.Promotions')}</span>}
                    </li> */}
        <li
          data-title={t("menu.Reports")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/reports`}
            className={`flex items-center gap-2 ${
              isActivereports ? "active" : ""
            }`}
            end
          >
            <img
              className="w-6 z-50"
              src="/assets/icons/Report.png"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
        <li
          data-title={t("menu.Settings")}
          className={` w-full tooltip gap-2 flex items-center relative  menu-border-color  py-3 ${
            openMenu || "justify-center"
          } `}
        >
          <NavLink
            to={`/${tenantUsername}/settings`}
            className={`flex items-center gap-2 ${
              isActivesettings ? "active" : ""
            }`}
            end
          >
            <img
              className="w-6 z-50"
              src="/assets/icons/setting-5-svgrepo-com 1.png"
              alt="Branch"
            />
            <span className="w-0 h-full bg-white absolute right-0 "></span>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default MenuSide;
